/**
 * @generated SignedSource<<be4ecea216d305759d830f21e23628f4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type salesChannelSwitchQueriesPollUnsubscribeTaskQuery$variables = {
  id: string;
};
export type salesChannelSwitchQueriesPollUnsubscribeTaskQuery$data = {
  readonly productSwitcherTask: {
    readonly id: string;
    readonly lastError: string;
    readonly state: number;
    readonly taskID: number;
  } | null;
};
export type salesChannelSwitchQueriesPollUnsubscribeTaskQuery = {
  response: salesChannelSwitchQueriesPollUnsubscribeTaskQuery$data;
  variables: salesChannelSwitchQueriesPollUnsubscribeTaskQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "ProductSwitcherTask",
    "kind": "LinkedField",
    "name": "productSwitcherTask",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "taskID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "state",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "lastError",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelSwitchQueriesPollUnsubscribeTaskQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "salesChannelSwitchQueriesPollUnsubscribeTaskQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "1e794a5c3a9d3e867e1be5b2c2acedd4",
    "id": null,
    "metadata": {},
    "name": "salesChannelSwitchQueriesPollUnsubscribeTaskQuery",
    "operationKind": "query",
    "text": "query salesChannelSwitchQueriesPollUnsubscribeTaskQuery(\n  $id: ID!\n) {\n  productSwitcherTask(id: $id) {\n    id\n    taskID\n    state\n    lastError\n  }\n}\n"
  }
};
})();

(node as any).hash = "ba399d9963ed8e653e1787652d49cc50";

export default node;
